module.exports = __webpack_public_path__ + "img/prioritas_k.e95b07fb.png";